module.exports = __webpack_public_path__ + "static/media/deal-discount-offer-with-purchase.02429ca5.png";